import { Box, Group, Paper, Stack } from '@mantine/core';
import { TemplateEditorContent } from './TemplateEditorContent';
import { TemplateEditorLanguageBar } from './TemplateEditorLanguageBar';
import { TemplateEditorSendingOptions } from './TemplateEditorSendingOptions';
import { TemplateEditorStatusBar } from './TemplateEditorStatusBar';
import { TemplateEditorTabs } from './TemplateEditorTabs';

export const TemplateEditorLayout = () => {
  return (
    <Paper w="100%" withBorder radius="md" style={{ overflow: 'hidden' }}>
      <Stack w="100%" gap={0}>
        <Box>
          <TemplateEditorTabs />
        </Box>

        <Box>
          <TemplateEditorSendingOptions />
        </Box>

        <Group gap={0} wrap="nowrap" align="stretch">
          <Box flex={1} miw={0}>
            <TemplateEditorContent />
          </Box>
          <Box w={90}>
            <TemplateEditorLanguageBar />
          </Box>
        </Group>

        <Box h={40}>
          <TemplateEditorStatusBar />
        </Box>
      </Stack>
    </Paper>
  );
};
